import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 600;
`;
